<template>
  <div v-if="!isKoreaTimezone">
    <div
      v-if="isDesktop"
      class="announce-bar timezone-warning-bar responsive-visible desktop"
    >
      <span class="announce-bar__content">
        해외 접속 시 이용이 원활하지 않습니다. 대한민국 표준시(UTC+9)로 변경 후 이용해주세요.
      </span>
      <a
        href="http://bit.ly/2sw6kaB"
        target="_blank"
      >
        더 알아보기
      </a>
    </div>
    <div
      v-else
      class="announce-bar timezone-warning-bar responsive-visible mobile"
    >
      <span class="announce-bar__content">
        해외 접속 시 이용이 원활하지 않습니다.
      </span>
      <a
        href="http://bit.ly/34sdr0V "
        target="_blank"
      >
        더 알아보기
      </a>
    </div>
  </div>
</template>

<script>
const KOREA_TIMEZONE_OFFSET = -540;

export default {
  name: 'TimeZoneWarningBar',
  props: {
    isDesktop: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isKoreaTimezone() {
      return (new Date()).getTimezoneOffset() === KOREA_TIMEZONE_OFFSET;
    },
  },
};
</script>
<style lang="scss">
  .announce-bar.timezone-warning-bar {
    background-color: #202020;

    a {
      color: white;
      text-decoration: underline white;
    }
  }
</style>